const steps = [
  {
    n: '01',
    title: 'Jessica reads your calendar',
    body: "She sees the invite, the dial-in details, the time. Everything needed to be there — so you don't have to be watching the clock.",
    callout: null,
  },
  {
    n: '02',
    title: 'She joins your bridge first',
    body: "Through our own conference bridge — independent of whoever is running the meeting. Your seat is held. Your presence is registered. The room moves on without you realizing it's already started.",
    callout: null,
  },
  {
    n: '03',
    title: 'She calls your phone — and keeps calling',
    body: "Not a notification. A direct phone call to your number. If you're on another call, she waits and tries again. She keeps going until you answer — or you press a button to stand her down.",
    callout: 'She is not deterred. She is not offended. Her job is to get through to you.',
  },
  {
    n: '04',
    title: 'She bridges you in, silently',
    body: "You join on mute. Screen visibility is yours immediately. Nobody knows you were forty-seven commits deep three minutes ago.",
    callout: null,
  },
];

export default function DialBackHowItWorks() {
  return (
    <section
      className="py-28 px-12 border-t border-white/[0.06] max-md:px-6 max-md:py-20"
      style={{ background: '#0e0d0b', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div className="max-w-[1100px] mx-auto">
        <div
          className="flex items-center gap-3 mb-4"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8472a' }}
        >
          <span className="block w-6 h-px bg-[#c8472a]" />
          How it works
        </div>

        <h2
          className="font-light leading-[1.1] text-[#f5f2ec]"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}
        >
          Four steps. No attention<br />
          <em className="italic text-[#9a9488]">required</em> from you.
        </h2>

        <div className="grid grid-cols-4 gap-[2px] mt-16 max-md:grid-cols-2 max-sm:grid-cols-1">
          {steps.map((step) => (
            <div
              key={step.n}
              className="p-7 bg-white/[0.02] border border-white/[0.06] rounded-[3px] transition-colors duration-200 hover:bg-white/[0.04]"
            >
              <div
                className="mb-4 text-[#c8472a]"
                style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', fontWeight: 500, letterSpacing: '0.1em' }}
              >
                {step.n}
              </div>
              <div
                className="text-[#f5f2ec] mb-3 leading-[1.25]"
                style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.25rem', fontWeight: 400 }}
              >
                {step.title}
              </div>
              <div className="text-[0.88rem] text-[rgba(245,242,236,0.6)] leading-[1.65]">
                {step.body}
              </div>
              {step.callout && (
                <div className="mt-4 p-3 bg-[rgba(200,71,42,0.08)] border-l-2 border-[#c8472a] text-[0.82rem] text-[rgba(245,242,236,0.8)] leading-[1.5]">
                  {step.callout}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
